import KoobTitle from '../../../components/Koob/KoobTitle';
import KoobParagraph from '../../../components/Koob/KoobParagraph';
import { useTranslation } from 'react-i18next';
import React from 'react';

export default function ExperienceExtrasModalHeader({
  recommendationMode,
  childrenExtraMode,
  currentExperienceName,
  nextExperienceName,
  // KD-3581 §4 — the modal opens from one of the two service bands, and which
  // one decides what a selection here applies to. Saying it in the header is
  // what keeps a global service from being read as a service of the day the
  // band was opened from.
  scope,
}) {
  const { t } = useTranslation('tripDesigner');

  return (
    <>
      {!recommendationMode && !childrenExtraMode && (
        <div>
          <KoobTitle>
            {scope
              ? t(`extrasModal.scopeTitle.${scope}`)
              : t('extrasModal.title')}
          </KoobTitle>

          <KoobParagraph>{t('extrasModal.description')}</KoobParagraph>

          {!!scope && (
            <KoobParagraph>{t(`extrasModal.scope.${scope}`)}</KoobParagraph>
          )}
        </div>
      )}

      {recommendationMode && (
        <div>
          <KoobTitle>{t('extrasModal.recommendation.title')}</KoobTitle>

          <KoobParagraph>
            {t('extrasModal.recommendation.description')}
            <br />
            {t('extrasModal.recommendation.forPrograms')}
            <strong>{currentExperienceName}</strong> &{' '}
            <strong>{nextExperienceName}</strong>.
          </KoobParagraph>
        </div>
      )}

      {childrenExtraMode && (
        <div>
          <KoobTitle>{t('extrasModal.childrenExtras.title')}</KoobTitle>
          <KoobParagraph>
            {t('extrasModal.childrenExtras.description')}
          </KoobParagraph>
        </div>
      )}
    </>
  );
}
